import { useCallback } from 'react';
import { TPlayerTag, useGetPlayerTags } from '@core/js/hooks/socket/hooks/useGetPlayerTags';
import { useSetPlayerTags } from 'server';
import { IGetPlayerTagsRequestData } from '@core/js/hooks/socket/hooks/useGetPlayerTags/types';

export const useSetTagByGetTagValue = () => {
    const getTag = useGetPlayerTags();
    const setPlayerTags = useSetPlayerTags();

    return useCallback(async (
        sendTagWithoutValue: string,
        getTagValue: IGetPlayerTagsRequestData
    ) => {
            const result = await getTag({ tagName:sendTagWithoutValue });
            if (result.tags.length) {
                const tagValue = result.tags?.find(el => el.name === sendTagWithoutValue)?.value;

                const tag = {
                    ...getTagValue,
                    value: tagValue
                } as TPlayerTag;

                try {
                    await setPlayerTags({ tags: [tag] });
                } catch (error) {
                    console.error(error);
                }
            }
    }, [getTag, setPlayerTags]);
};
